export const getPartnerSignupErrorCode = state => state.partnerSignup.errorCode;
export const getPartnerSignupStatus = state => state.partnerSignup.status;
export const getPartnerSignupIsLoading = state => state.partnerSignup.isLoading;
export const getPartnerSignupEmailSent = state => state.partnerSignup.emailSent;
